import React from "react"
import { BrowserRouter } from "react-router-dom"
import { ThemeProvider } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Body } from "src/Body"
import { DefaultTheme } from "src/themes/default"
import "./App.css"
import { RecoilRoot } from "recoil"
import { LoginProvider } from "./providers/LoginProvider"

function App() {
  return (
    <ThemeProvider theme={DefaultTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          <RecoilRoot>
            <LoginProvider>
              <Body />
            </LoginProvider>
          </RecoilRoot>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  )
}

export default App
